// ----------------------------------------------------------------------

const account = {
  displayName: 'YouTube Subscribers',
  email: 'demo@digitalaimz.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
